import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import { FileUploader } from "react-drag-drop-files";
import Colors from "../../theme/colors.json";
import CONSTANTS, { Historical_Data_Note } from "../../constants/constants";
import { Button, IconButton } from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { uploadHistoricData } from "../../services/ProposalService";
import { pushNotification } from "../../redux/actions";
import { useDispatch } from "react-redux";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import CloseIcon from "@mui/icons-material/Close";

const useStyles = makeStyles((theme) => ({
  uploadContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
    background: Colors.WHITE_BACKGROUND,
    padding: 10,
    borderRadius: 10,
    height: "20rem",
  },
  uploadHeading: {},
  uploadContent: {},
  uploadText: {
    fontSize: theme.fontSizes.SMALL,
    fontWeight: 700,
  },
  progressDiv: {
    height: 200,
    width: 200,
  },
  fileTypeImg: {
    height: "2.5rem",
    width: "2.5rem",
  },
  fileLogoContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    "&:hover $closeIcon": {
      display: "block",
    },
  },
  closeIcon: {
    position: "absolute",
    backgroundColor: Colors.BG_GRAY,
    display: "none",
    borderRadius: 50,
  },
}));

const DataUpload = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const fileTypes = ["XLSX", "CSV"];
  const [file, setFile] = useState<any>(null);
  const [progress, setProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  const CircleStyle = {
    // Rotation of path and trail, in number of turns (0-1)
    rotation: 0.25,

    // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
    strokeLinecap: "butt",

    // Text size
    textSize: "16px",

    // How long animation takes to go from one percentage to another, in seconds
    pathTransitionDuration: 0.5,

    // Can specify path transition in more detail, or remove it entirely
    // pathTransition: 'none',

    // Colors
    pathColor: Colors.GRAPH_PRIMARY_COLOR,
    textColor: Colors.GRAPH_PRIMARY_COLOR,
    trailColor: "#d6d6d6",
    backgroundColor: "#3e98c7",
  };

  const handleFileChange = (file: any) => {
    setFile(file);
  };

  const handleFileUpload = async (file) => {
    setIsUploading(true);
    const response = await uploadHistoricData(file, setProgress);
    if (response?.success) {
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );
      clearFile();
      setIsUploading(false);
    } else {
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.ERROR,
          message: response?.message,
        })
      );
      setProgress(0);
      setIsUploading(false);
    }
  };

  const clearFile = () => {
    setFile(null);
    setProgress(0);
  };

  return (
    <>
      <div className={classes.uploadContainer}>
        {/* <div className={classes.uploadHeading}>Historical data Upload</div> */}
        {!isUploading ? (
          <>
            {!file && (
              <FileUploader
                handleChange={handleFileChange}
                name="file"
                types={fileTypes}
                file={file}
              />
            )}
            <>
              {file?.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" && (
                <div className={classes.fileLogoContainer}>
                  <img
                    className={classes.fileTypeImg}
                    src="https://cdn-icons-png.flaticon.com/512/9496/9496502.png"
                  />
                  <div>{file?.name}</div>
                  <div className={classes.closeIcon}>
                    <IconButton
                      size="small"
                      onClick={clearFile}
                      disabled={file ? false : true}
                    >
                      <CloseIcon color="primary" />
                    </IconButton>
                  </div>
                </div>
              )}

              {file?.type === "text/csv" && (
                <div className={classes.fileLogoContainer}>
                  <img
                    className={classes.fileTypeImg}
                    src="https://cdn-icons-png.flaticon.com/512/172/172534.png"
                  />
                  <div>{file?.name}</div>
                  <div className={classes.closeIcon}>
                    <IconButton
                      size="small"
                      onClick={clearFile}
                      disabled={file ? false : true}
                    >
                      <CloseIcon color="primary" />
                    </IconButton>
                  </div>
                </div>
              )}
            </>
            <Button
              variant="contained"
              size="small"
              startIcon={<FileUploadIcon />}
              onClick={() => handleFileUpload(file)}
              disabled={file ? false : true}
            >
              Upload
            </Button>
          </>
        ) : (
          <div className={classes.progressDiv}>
            <CircularProgressbar
              value={progress}
              text={`${progress}%`}
              styles={buildStyles(CircleStyle)}
            />
          </div>
        )}
        <div className={classes.uploadText}>{Historical_Data_Note}</div>
      </div>
    </>
  );
};

export default DataUpload;
